import * as React from 'react';

interface IProps {
  width?: number;
}

export default (props: IProps) => {
  const {width} = props;

  return (
    <svg
      width={width}
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      version="1.1"
      id="svg448"
      xmlns="http://www.w3.org/2000/svg">
      <circle id="Oval" cx="35" cy="35.155212" fill="#0088ff" r="35" />
      <g
        id="g8"
        transform="matrix(0.40074534,0,0,0.40074534,14.980254,14.962733)">
        <path
          fill="#ffffff"
          d="M 91.1,85.7 C 90,76.9 81.6,72.3 76.1,70.1 l -8.9,15 -0.8,-10.3 2.1,-4.8 h -8 l 2,4.8 -0.8,10.3 -8.8,-15 c -5.6,2.1 -13.9,6.7 -15,15.6 -0.2,1.3 0.4,2.5 1.4,3.2 3,2.1 10.6,6.1 25.2,6.1 v 0 0 c 14.6,0 22.2,-4 25.2,-6.1 1,-0.7 1.5,-1.9 1.4,-3.2 z m -10.2,2 h -7.8 v -2.1 h 7.8 z"
          id="path2"
        />
        <ellipse
          fill="#ffffff"
          cx="64.5"
          cy="52.799999"
          rx="13.3"
          ry="14"
          id="ellipse4"
        />
        <path
          fill="#ffffff"
          d="M 41.4,72.9 H 31.2 v -3.7 h 15.4 c 1.1,-0.6 2.2,-1.1 3.3,-1.6 v 0 L 53.4,66 c -3.6,-3.2 -5.8,-7.9 -5.8,-13.2 0,-9.6 7.5,-17.4 16.8,-17.4 1.5,0 2.9,0.2 4.3,0.6 V 13.6 c 0,-0.9 -0.8,-1.7 -1.7,-1.7 H 52 V 7.2 C 52,6 51,5 49.8,5 H 27.7 C 26.5,5 25.5,6 25.5,7.2 V 12 h -15 c -0.9,0 -1.7,0.8 -1.7,1.7 v 76.4 c 0,1.3 1.1,2.3 2.3,2.3 H 32.7 V 74.8 h 6.5 c 0.8,-0.7 1.5,-1.3 2.2,-1.9 z M 58.3,24.4 h 4.3 v 9.8 h -4.3 z m -5.6,0 H 57 v 9.8 H 52.7 Z M 38.6,54.6 h -4.3 v -9.8 h 4.3 z m 0,-20.3 h -4.3 v -9.8 h 4.3 z m 5.6,20.3 h -4.3 v -9.8 h 4.3 z m 0,-20.3 h -4.3 v -9.8 h 4.3 z m -24,42.2 H 16 v -9.8 h 4.3 v 9.8 z m 0,-21.9 H 16 v -9.8 h 4.3 v 9.8 z m 0,-20.3 H 16 v -9.8 h 4.3 v 9.8 z m 5.6,42.2 h -4.3 v -9.8 h 4.3 z m 0,-21.9 h -4.3 v -9.8 h 4.3 z m 0,-20.3 h -4.3 v -9.8 h 4.3 z"
          id="path6"
        />
      </g>
    </svg>
  );
};
